import React from 'react'
import whyDidYouRender from '@welldone-software/why-did-you-render'

import { appConfig } from './services/config'

if (process.env.MODE === 'development' && appConfig.isRerenderLogShown) {
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  })
}
